// Computed state
export const COMPUTED_PRICING_POLICY_STATUS = {
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED',
  DRAFT: 'DRAFT',
  UPCOMING: 'UPCOMING',
  EXPIRED: 'EXPIRED',
} as const;
export const DEFAULT_FILTER_COMPUTED_PRICING_POLICY_STATUS = [
  COMPUTED_PRICING_POLICY_STATUS.DRAFT,
  COMPUTED_PRICING_POLICY_STATUS.ACTIVE,
  COMPUTED_PRICING_POLICY_STATUS.UPCOMING,
  COMPUTED_PRICING_POLICY_STATUS.EXPIRED,
] as const;
